import { linkMoreThanOneAccountData } from "constants-lib/seo/linkMoreThanOneAccountData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

export const getLinkMoreThanOneAccount = (schemaData) => {
  const data = schemaData.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add Link more than One Account JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addLinkMoreThanOneAccount = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-to-link-up-more-than-one-account-if-i-have-multiple`,
    ) &&
    document.getElementById(`linkMoreThanOneAccount`) === null
  ) {
    const script = linkMoreThanOneAccountJSONLD()
    addJSONLDToHead(script, `linkMoreThanOneAccount`)
  } else {
    removeElement(`linkMoreThanOneAccount`)
  }
}

// JSON LD template for Link more than One Account
const linkMoreThanOneAccountJSONLD = () => {
  const linkMoreThanOneAccountTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getLinkMoreThanOneAccount(linkMoreThanOneAccountData),
  }
  return linkMoreThanOneAccountTemplate
}
